import NotificationSetting from './NotificationSetting';

export default NotificationSetting;
